// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/captain/captain.actions.go

export const REMOVE_WIF_AUTH_BINDING =
  "mondoo.captain.Captain.RemoveWIFAuthBinding";
